import { useContext, useEffect, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useConfigColumn = ({ configColumnPopup, getWeightMetricsFormula }) => {


    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [rowData, setRowData] = useState([])
    const [newCol, setNewCol] = useState({ formula_id: 0, column_display_name: '', column_expression: '', is_active: true });

    const columns = [
        {
            key: "column_display_name",
            label: "Label",
            style: { width: "30%" },

        },
        {
            key: "column_expression",
            label: "Formula",
            style: { width: "50%" },
            render: (row) => (
                <code className="bg-light p-1 rounded text-danger">{row.column_expression}</code>
            )
        },
        {
            key: "isActive",
            label: "Active",
            headerStyle: { textAlign: "center" },
            style: { width: "10%", textAlign: "center" },
            render: (row) => (
                <div className=" d-flex justify-content-center">
                    <input
                        type="checkbox"
                        checked={row.is_active}
                        onChange={(e) => upsertDynamicColumn('isActive', e.target.checked, row)}
                    />
                </div>
            )
        },
        {
            key: "action",
            label: "Action",
            headerStyle: { textAlign: "center" },
            style: { width: "10%", textAlign: "center", borderRight: "1px solid #ddd" },
            render: (row) => (
                <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => setNewCol(row)} /></div>
            )
        }
    ];

    useEffect(() => {
        setRowData(configColumnPopup?.data)
    }, [configColumnPopup?.data])

    const upsertDynamicColumn = async (key, newValue, row) => {
        try {
            const data = key === "isActive" ? row : newCol;
            if (!data?.column_display_name?.trim() || !data?.column_expression?.trim()) {
                showInfo("Info", "Please provide both a column name and an expression");
                return;
            }
            const payload = {
                "formula_id": data?.formula_id || 0,
                "column_display_name": data?.column_display_name,
                "column_expression": data?.column_expression,
                "is_active": key === "isActive" ? newValue : data?.is_active
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTWEIGHTMETRICSFORMULADETAIL"), payload)
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                getWeightMetricsFormula();
                setNewCol({ formula_id: 0, column_display_name: '', column_expression: '', is_active: true })
            } else {
                showError('Error', res?.body.errorMessage);
            }

        } catch (error) {
            console.error("error:::", error)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === "is_active") {
            setNewCol((prev) => ({ ...prev, [name]: e.target.checked }))
        } else {
            setNewCol((prev) => ({ ...prev, [name]: value }))
        }
    }

    return { columns, newCol, upsertDynamicColumn, rowData, handleChange }
}